export default __webpack_public_path__ + "static/media/touchpad3-Inactive_v1.7541e67e.svg";